var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.67045 13C8.9686 13.0487 9.27461 13.074 9.58655 13.074C9.89848 13.074 10.2045 13.0487 10.5026 13H8.67045ZM18.0491 24.9162C18.6702 24.9162 19.1729 24.4076 19.1729 23.7885H19.1727C19.1727 18.494 14.8808 14.2017 9.58634 14.2017C4.29185 14.2017 0 18.494 0 23.7885C0 24.4096 0.505835 24.9162 1.12379 24.9162H18.0491ZM1.12792 23.7885C1.12792 19.1166 4.91507 15.3299 9.58655 15.3299C14.258 15.3299 18.0453 19.1166 18.0492 23.7885C18.0492 23.7885 1.12792 23.7869 1.12792 23.7885Z",
    fill: "#555555"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.51453,
    cy: 6.39637,
    r: 5.54812,
    stroke: "#A2A2A2",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8513 24.9157C18.4578 24.9157 18.9487 24.4191 18.9487 23.8145H18.9485C18.9485 18.6445 14.7575 14.4531 9.58752 14.4531C4.4175 14.4531 0.226562 18.6445 0.226562 23.8145C0.226562 24.421 0.720505 24.9157 1.32393 24.9157H17.8513ZM1.32796 23.8145C1.32796 19.2524 5.02607 15.5547 9.58772 15.5547C14.1494 15.5547 17.8476 19.2524 17.8514 23.8145C17.8514 23.8145 1.32796 23.8129 1.32796 23.8145Z",
    fill: "#555555"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.527acbc5edbd49d1f51460466300257b.svg";
export { ForwardRef as ReactComponent };